import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';
import { InputUniDriver } from '../Input/Input.uni.driver';

export type EditableTitleInputDriver = Pick<
  InputUniDriver,
  | 'enterText'
  | 'keyDown'
  | 'blur'
  | 'focus'
  | 'isFocus'
  | 'getMaxLength'
  | 'getValue'
  | 'getText'
>;

export interface EditableTitleUniDriver extends BaseUniDriver {
  getInput: () => EditableTitleInputDriver;
  getHeadingText: (idx: number) => Promise<string>;
  clickHeading: (idx: number) => Promise<void>;
}
